import Vue from 'vue'
import { PageHeader, Form, Input, Select, Button, message, Spin, Modal } from 'ant-design-vue'
import ImgCaptcha from '@/components/imgcaptcha'
import MobileVerification from '@/components/mobileverification'

Vue.use(PageHeader)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Spin)
Vue.use(ImgCaptcha)
Vue.use(MobileVerification)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$info = Modal.info
